import React from "react";

const SearchAbleList = ({ destRef, onChange, filterOptions }) => {

    return <input
                ref={destRef}
                className="form-control"
                type="text"
                list="searchablelist"
                autoComplete="off"
                id="search"
                onChange={onChange}
                onInput={filterOptions}
            />
}


export default SearchAbleList;